module.exports = __webpack_public_path__ + "static/media/funnel_data_sample.e82ba3f6.png";